import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { Store } from 'redux';
import { About } from '../../pages/about/about';
import { Home } from '../../pages/home';
import { Accessibility } from '../../pages/accessibility/accessibility';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../styles/materialTheme';
import themeSvensk from '../../styles/materialThemeSvensk';
import './root.scss';
import { Menu } from '../menu/menu';
import Loader from '../loader/loader';
import { ApplicationState } from '../../store';
import { Site } from '../../store/settings/types';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { Contact } from '../../pages/contact';
import { ErrorBoundary } from '../errorBoundary/errorBoundary';
import { reactPlugin, appInsight} from '../../applicationInsights';
import {RefundSheep} from '../../pages/refundSheep';
import {RefundReindeer} from '../../pages/refundReindeer';
import {useEffect} from 'react';
import {ReportDodeRovdyr} from '../../pages/report/reportdoderovdyr';
import {ReportRovviltskade} from '../../pages/report/reportrovviltskade';
import {ReportRovviltskadeNorge} from '../../pages/report/reportrovviltskadeNorge';
export const history = createBrowserHistory();

type RootProps = {
    store: Store;
};

function Root(): React.ReactElement {
    const site = useSelector((state: ApplicationState) => state.settings.site);
    const themeCurrent = site === Site.SE ? themeSvensk : theme;
    const colorTheme = site === Site.SE ? 'nv' : 'md';
    document.documentElement.lang = useSelector((state: ApplicationState) => state.settings.language);

    useEffect(() => {
        document.documentElement.setAttribute(
            'data-color-theme',
            colorTheme
        );
    }, [colorTheme]);

    
    return (
        <Router>
            <ThemeProvider theme={themeCurrent}>
                <Menu />
                <Routes>
                    <Route path={'/'} element={<Home />} />
                    <Route path={'/test'} element={<Loader />} />
                    <Route path={'/filter'} element={<Home />} />
                    <Route path={'/individ'} element={<Home />} />
                    <Route path={'/search'} element={<Home />} />
                    <Route path={'/rapport/doderovdyr'} element={<ReportDodeRovdyr />} />
                    <Route path={'/rapport/rovviltskade'} element={<ReportRovviltskade />} />
                    <Route path={'/rapport/rovviltskadenorge'} element={<ReportRovviltskadeNorge />} />
                    <Route path={'/erstatning/sau'} element={<RefundSheep />} />
                    <Route path={'/erstatning/rein'} element={<RefundReindeer />} />
                    <Route path={'/om'} element={<About />} />
                    <Route path={'/kontakt'} element={<Contact />} />
                    <Route path={'/tilgjengelighet'} element={<Accessibility />} />
                    
                    {/* Fallback for unknown urls */}
                    <Route path={'/*'} element={<Navigate to="/" replace />} />
                </Routes>
            </ThemeProvider>
        </Router>
    );
}

function _Root({ store }: RootProps): React.ReactElement {
    return (
        <Provider store={store}>
            <ErrorBoundary>
                <Root />
            </ErrorBoundary>
        </Provider>
    );
}

const rootExport = appInsight ? withAITracking(reactPlugin, _Root, null, 'contentWrapper') : _Root;

// @ts-ignore
export default rootExport;

